import React, { memo } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { colorVariables } from 'theme/variables';
import IconStyled from './styles/IconStyled';

const Icon = ({ name, color, size, width, height, viewBox, className }) => (
  <IconStyled
    className={className}
    fill={get(colorVariables, color, color)}
    width={viewBox !== 'none' ? size : width}
    height={viewBox !== 'none' ? size : height}
    viewBox={viewBox !== 'none' ? '0 0 32 32' : null}
  >
    <use xlinkHref={`#${name}`} />
  </IconStyled>
);

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  size: PropTypes.number,
  viewBox: PropTypes.string,
  className: PropTypes.string,
};

Icon.defaultProps = {
  color: 'white',
  width: null,
  height: null,
  size: null,
  viewBox: null,
  className: '',
};

export default memo(Icon);
